import React from 'react';
import Chart from "react-apexcharts";
import {Card, Image, OverlayTrigger, Tooltip} from 'react-bootstrap'; 
import * as helpers from '../../utils/helpers'; 
import { MetricType } from 'models/enums';

type ChartType = "line" | "area" | "bar" | "pie" | "donut" | "radialBar" | "scatter" | "bubble" | "heatmap" | "candlestick" | "boxPlot" | "radar" | "polarArea" | "rangeBar" | "rangeArea" | "treemap" | undefined;  

interface MetricCardProps {
    title: string;
    value: number;
    type: MetricType; 
    icon: React.ReactElement;
    series?: {
      type: ChartType;
      seriesData: number[];
      categories: string[];
    }
    handleClick?: () => void;
    toolTipText?: string;  
    shortValue?: boolean;
  }
  
  interface TrendMetricCardProps extends MetricCardProps {
    trend: number;
  }  
  
const SimpleMetricCard: React.FC<MetricCardProps> = ({ title, value, type, icon, series, handleClick, toolTipText, shortValue }) => {  
  const prefix = type === MetricType.Money ? '$' : '';   
  const options: ApexCharts.ApexOptions = series ? {  
    chart: {
      type: series?.type || 'bar',
      sparkline: {
        enabled: true
      },          
    },
    plotOptions: {
      bar: {
        columnWidth: '80%'
      }
    },
    xaxis: {
      categories: series?.categories,
      crosshairs: {
        width: 1
      },
    },
    stroke: {
      curve: 'straight',
      width: 2
    },
    tooltip: {
      fixed: {
        enabled: false
      },
      x: {
        show: false
      },
      y: {
        title: {
          formatter: function (seriesName:string) {
            return '';
          }
        }
      },
      marker: {
        show: false
      },      
    }
  } : {};

  const renderIcon = () => {
    if(toolTipText)
      return (
        <OverlayTrigger
              key="overlayTrigger"
              placement="top"                                                            
              overlay={
                  <Tooltip className="my-tooltip2" id="af-tooltip">{toolTipText}</Tooltip>
              }              
          >{icon}</OverlayTrigger>
    ); 
    return (
      <>{icon}</>
    ); 
  }

  const hasValue = value !== null && value !== undefined && !Number.isNaN(Number(value));
  const formattedValue = hasValue
    ? (shortValue ? helpers.nFormatter(Number(value), 1, prefix) : prefix + Number(value).toLocaleString())
    : (type === MetricType.Money ? '$0' : '0');

  return (
    <Card 
      className="metric-card"
      style={{cursor: handleClick ? "pointer" : ""}}
      onClick={handleClick}
      >
      <Card.Title>        
        <div className="metric-icon">          
          {renderIcon()}
        </div>        
        <div className="metric-title">{title || '\u00A0'}</div>
      </Card.Title>          
      <Card.Body>
        <div className="metric-value">{formattedValue}</div>
        {series && 
          <div className="metric-chart">
            <Chart 
              options={options} 
              series={[{ data: series?.seriesData || [] }]} 
              type={series?.type} 
              height={60} 
            />
          </div>
        }        
      </Card.Body>      
    </Card>
  );
};

export default SimpleMetricCard;